export default __webpack_public_path__ + "static/media/ICICI.a181a6b2.svg";